import { newPageInfo } from "@hex-insights/router";
import { hubsPageInfo } from "../pageinfo";

export const permissionHubPageInfo = newPageInfo({
	title: "Permissions",
	description: "Pages related to the Permission model.",
	exact: false,
	to: hubsPageInfo.to + "/permissions",
	path: hubsPageInfo.path + "/permissions",
	parent: hubsPageInfo,
});
